<template>
  <form @submit.prevent>
    <!--        You can switch " data-color="primary" "  with one of the next bright colors: "green", "orange", "red", "blue"       -->
    <div class="text-center pt-80">
      <h2 class="title">방내놓기</h2>
      <div class="col-lg-10 col-md-11 pt-20" style="margin: auto">
        <div>
          <ul class="nav nav-pills" role="tablist" style="margin: auto">
            <li
              v-for="(tab, index) in tabs"
              :key="tab.title"
              role="tab"
              :tabindex="tab.checked ? 0 : ''"
              :id="`step-${tab.tabId}`"
              :aria-controls="tab.tabId"
              :aria-disabled="tab.active"
              :aria-selected="tab.active"
              :ref="`tab-${index}`"
              class="nav-item wizard-tab-link jipvio-step-li"
            >
              <a
                class="nav-link"
                @click="navigateToTab(index)"
                :class="[
                  { 'disabled-wizard-link': !tab.checked },
                  { active: tab.active },
                  { checked: tab.checked }
                ]"
                data-toggle="tab"
              >
                <tab-item-content :tab="tab"></tab-item-content>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!--
            <div
              class="moving-tab"
              :class="{ 'error-link': activeTab.hasError }"
              v-if="activeTab"
              style="transition: transform 0.5s cubic-bezier(0.29, 1.42, 0.79, 1); width: 100%;"
              :style="movingTabStyles"
            >
              <tab-item-content
                :tab="activeTab"
                :moving-tab="true"
              ></tab-item-content>
            </div>
      -->
    </div>

    <slot :activeIndex="activeTabIndex" :activeTab="activeTab"></slot>

    <slot name="footer" :next-tab="nextTab" :prev-tab="prevTab">
      <div class="col-md-10 m-auto">
        <div class="">
          <div class="pull-right">
            <n-button
              v-if="activeTabIndex < tabCount - 1"
              wide
              @click.native="nextTab"
              class="btn-next"
              >{{ nextButtonText }}</n-button
            >
            <n-button v-else wide @click.native="nextTab">
              {{ finishButtonText }}
            </n-button>
          </div>

          <div class="pull-left">
            <n-button
              v-if="activeTabIndex > 0"
              wide
              @click.native="prevTab"
              class="btn-previous"
              >{{ prevButtonText }}</n-button
            >
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </slot>
  </form>
</template>
<script>
import { throttle } from "./throttle";
import { Button } from "@/components";

export default {
  name: "simple-wizard",
  props: {
    startIndex: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "제목"
    },
    subTitle: {
      type: String,
      default: "부제목"
    },
    prevButtonText: {
      type: String,
      default: "이전"
    },
    nextButtonText: {
      type: String,
      default: "다음"
    },
    finishButtonText: {
      type: String,
      default: "완료"
    },
    vertical: {
      type: Boolean
    }
  },
  components: {
    [Button.name]: Button,
    TabItemContent: {
      props: ["tab", "movingTab"],
      render(h) {
        return h("span", [this.tab.$slots.label || this.tab.label]);
      }
    }
  },
  provide() {
    return {
      addTab: this.addTab,
      removeTab: this.removeTab
    };
  },
  data() {
    return {
      tabs: [],
      activeTabIndex: 0,
      tabLinkWidth: 0,
      tabLinkHeight: 50
    };
  },
  computed: {
    tabCount() {
      return this.tabs.length;
    },

    linkWidth() {
      let width = 25;
      let height = "50px";
      /*
      if (this.tabCount > 0) {
        width = 100 / this.tabCount;
      }
      */
      if (this.vertical) {
        width = 50;
      }
      return { width: `${width}%`, height: "50px" };
      // return { width: "25%", height: "50px" };
    },
    linkHeight() {
      let height = 50;
      if (this.tabCount > 0) {
        height = 50 / this.tabCount;
      }
      if (this.vertical) {
        height = 50;
      }
      return { height: "50px" };
    },
    activeTab() {
      return this.tabs[this.activeTabIndex];
    },
    movingTabStyles() {
      let translateXValue = this.tabLinkWidth * this.activeTabIndex;
      let translateYValue = 0;
      if (this.vertical) {
        translateYValue = this.tabLinkHeight * this.activeTabIndex;
        translateXValue = 0;
      }
      let styles = {
        transform: `translate3d(${translateXValue}px, ${translateYValue}px, 0px)`
      };
      if (this.tabLinkWidth !== 0) {
        styles.width = `${this.tabLinkWidth}px`;
      }
      return styles;
    }
  },

  created() {},

  methods: {
    addTab(tab) {
      const index = this.$slots.default.indexOf(tab.$vnode);
      let tabTitle = tab.title || "";
      tab.tabId = `${tabTitle.replace(/ /g, "")}${index}`;
      if (!this.activeTab && index === 0) {
        tab.active = true;
        tab.checked = true;
      }
      if (this.activeTab === tab.name) {
        tab.active = true;
        tab.checked = true;
      }
      this.tabs.splice(index, 0, tab);
    },
    removeTab(tab) {
      const tabs = this.tabs;
      const index = tabs.indexOf(tab);
      if (index > -1) {
        tabs.splice(index, 1);
      }
    },
    validate(tab) {
      let tabToValidate = tab || this.activeTab;
      let beforeChange = tabToValidate.beforeChange;
      if (beforeChange) {
        return Promise.resolve(beforeChange())
          .then(res => {
            this.activeTab.hasError = res ? false : true;
            return res;
          })
          .catch(() => {
            this.activeTab.hasError = true;
          });
      } else {
        return Promise.resolve(true);
      }
    },
    async nextTab() {
      let isValid = await this.validate();
      if (isValid && this.activeTabIndex < this.tabCount - 1) {
        this.activeTabIndex++;
      }
      return isValid;
    },
    prevTab() {
      this.activeTabIndex--;
    },
    async navigateToTab(index) {
      if (this.tabs[index].checked) {
        // recursively validate each tab
        if (index > this.activeTabIndex) {
          let valid = await this.nextTab();
          if (valid) {
            this.navigateToTab(index);
          }
        } else {
          this.activeTabIndex = index;
        }
      }
    },
    onResize() {
      let tabLinks = document.getElementsByClassName("wizard-tab-link");
      if (tabLinks.length > 0 && this.tabCount > 0) {
        let { clientWidth, clientHeight } = tabLinks[0];
        this.tabLinkWidth = clientWidth;
        this.tabLinkHeight = clientHeight;
      }
    }
  },
  mounted() {
    const self = this;

    this.activeTabIndex = this.startIndex;
    this.$nextTick(() => {
      this.tabs[this.activeTabIndex].active = true;
      this.tabs[this.activeTabIndex].checked = true;
      this.onResize();
    });
    window.addEventListener(
      "resize",
      () => {
        throttle(this.onResize, 40);
      },
      false
    );
  },
  watch: {
    activeTabIndex(newValue, oldValue) {
      if (newValue !== oldValue) {
        let oldTab = this.tabs[oldValue];
        let newTab = this.tabs[newValue];
        oldTab.active = false;
        newTab.active = true;

        if (!newTab.checked) {
          newTab.checked = true;
        }
        this.$emit("tab-change", oldTab, newTab);
        this.$emit("update:startIndex", newValue);
      }
    }
  }
};
</script>
<style lang="scss">
/* Tab content animation */
.tab-content {
  display: flex; // to avoid horizontal scroll when animating
  .tab-pane {
    display: block;
    animation: fadeIn 0.5s;
    width: 100%;
  }
}

/**
    Extra niceties. Display error tabs and disable navigation unvisited tabs
   */
.wizard-navigation .nav-link {
  &.active,
  &.checked {
    cursor: pointer;
  }
}

.disabled-wizard-link {
  cursor: not-allowed;
}

/*sohyun*/
/*숫자 1,2,3,4 넘버링될 수 있게 작업해주세요!! */
.jipvio-step-li {
  position: relative;
  width: 228px;
  height: 66px;
}
/*STEP*/
.jipvio-step-li:nth-child(1) {
  margin-left: 0;
}
.jipvio-step-li:nth-child(4) {
  margin-right: 0;
}
a.nav-number-round {
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 60px;
  padding: 3px 11px;
  color: #000000 !important;
  text-align: center;
  position: absolute;
  left: 7px;
  top: 6px;
}
.nav-pills .nav-item .nav-link.active,
.nav-pills .nav-item .nav-link.active:focus,
.nav-pills .nav-item .nav-link.active:hover {
  background-color: rgb(90, 47, 202) !important;
}
.nav-pills .nav-item .nav-link.active {
  color: #ffffff !important;
}
.nav-pills .nav-item .nav-link {
  background-color: rgb(244, 245, 247) !important;
  color: #373737 !important;
}

@media screen and (max-width: 1200px) {
  /*방내놓기 네비바*/
  .jipvio-step-li {
    width: 180px;
    height: 43px;
  }
  a.nav-number-round ~ span {
    margin-left: 5px;
  }
}

@media screen and (max-width: 991px) {
  /*방내놓기 네비바*/
  .jipvio-step-li {
    width: 170px;
    height: 43px;
  }
  a.nav-number-round ~ span {
    margin-left: 10px;
  }
}
@media screen and (max-width: 786px) {
  .jipvio-step-li {
    width: 48%;
    height: 43px;
    margin-bottom: 1vh;
  }
  .jipvio-step-li:nth-child(1) {
    margin-left: 0;
    margin-right: 2%;
    margin-bottom: 1vh;
  }
  .jipvio-step-li:nth-child(2) {
    margin-left: 2%;
    margin-right: 0;
    margin-bottom: 1vh;
  }
  .jipvio-step-li:nth-child(3) {
    margin-left: 0;
    margin-right: 2%;
  }
  .jipvio-step-li:nth-child(4) {
    margin-left: 2%;
    margin-right: 0;
  }
}
</style>
